
const Services = () => {
  const services = [
    {
      icon: 'ri-funds-line',
      title: 'Wealth Management',
      description: 'Comprehensive investment strategies designed to grow and protect your wealth over time with expert portfolio management.',
      features: ['Portfolio Management', 'Asset Allocation', 'Risk Assessment']
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Retirement Planning',
      description: 'Strategic planning to ensure a comfortable retirement with sustainable income streams and tax-efficient strategies.',
      features: ['Pension Planning', 'Income Strategies', 'Tax Optimisation']
    },
    {
      icon: 'ri-building-line',
      title: 'Estate Planning',
      description: 'Protect your legacy and ensure your assets are distributed according to your wishes with comprehensive estate strategies.',
      features: ['Inheritance Planning', 'Trust Services', 'Wealth Transfer']
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Risk Management',
      description: 'Comprehensive insurance and protection strategies to safeguard your financial future against unexpected events.',
      features: ['Life Insurance', 'Income Protection', 'Critical Illness Cover']
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Business Planning',
      description: 'Tailored financial solutions for business owners including succession planning and corporate wealth strategies.',
      features: ['Business Succession', 'Corporate Pensions', 'Key Person Insurance']
    },
    {
      icon: 'ri-pie-chart-line',
      title: 'Investment Advisory',
      description: 'Expert guidance on investment opportunities with personalised strategies aligned to your risk profile and goals.',
      features: ['Market Analysis', 'Portfolio Review', 'Investment Selection']
    }
  ];

  return (
    <section id="services" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-[#1B3A5F] mb-4">
            Our <span className="text-[#F5A623]">Services</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Comprehensive financial planning solutions tailored to your unique needs and goals
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 group hover:-translate-y-1"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-[#F5A623] to-[#E09612] rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${service.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#1B3A5F] mb-3">{service.title}</h3>
              <p className="text-gray-600 text-sm mb-4 leading-relaxed">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-[#F5A623] mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <button
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) {
                const offset = 80;
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - offset;
                window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
              }
            }}
            className="bg-[#F5A623] text-white px-8 py-3.5 rounded-lg text-base font-semibold hover:bg-[#E09612] transition-colors shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Discuss Your Needs
          </button>
        </div>
      </div>
    </section>
  );
};

export default Services;
